/**
 * Retorna o nome de exibicao de um perfil, priorizando o nome da pessoa e
 * caindo para o nome da empresa (companyName/corporateName) quando for PJ.
 * @param user objeto de perfil retornado da store (userProfile.user)
 */
export function getProfileDisplayName(user: any): string {
    if (!user) return '';
    return user.name || user.companyName || user.corporateName || '';
}

/**
 * Retorna a primeira palavra de um texto (ex.: primeiro nome).
 * @param value texto de origem
 */
export function getFirstWord(value: string): string {
    if (!value) return '';
    const trimmed = String(value).trim();
    const idx = trimmed.indexOf(' ');
    return idx > 0 ? trimmed.substring(0, idx) : trimmed;
}
